define('payment/handlers/paymentMethodHandlers/trustlyWithdrawMethodHandler',[],function () {
	'use strict';

	function setupFormTemplate(paymentBox) {
		var $amountBox = paymentBox.$box.find('.amount-box');
		$amountBox.find('input').val('0');
		$amountBox.parent().hide();

		paymentBox.$box.find('.fee-box').hide();
	}

	var trustlyWithdrawMethodHandler = {};
	trustlyWithdrawMethodHandler.setupFormTemplate = setupFormTemplate;
	return trustlyWithdrawMethodHandler;
});

